export const setDocumentLanguage = (language) => {
	document.documentElement.lang = language || 'en';
};
